// Libraries
var React = require('react');

// Styles
require('./LatestResults.scss');

class LatestResults extends React.Component {
    constructor(props) {
        super(props);
        
        this.results = [];
        this.state = {
            latestResult: "",
            fadeInAndOut: false
        }
    }

    componentDidMount = () => {
        var self = this;
        this.results = this.props.results;
        window.setInterval(function() {
            if(self.results.length > 0) {
                var nextResult = self.results.pop();
                var latestResult = (nextResult.HomeTeam.TeamCode !== "" ? nextResult.HomeTeam.TeamCode : nextResult.HomeTeam.TeamName) + " " + nextResult.HomeTeam.Score + " - " + nextResult.AwayTeam.Score + " " + (nextResult.AwayTeam.TeamCode !== ""?  nextResult.AwayTeam.TeamCode :  nextResult.AwayTeam.TeamName);
               
                self.setState({
                    latestResult: latestResult,
                    fadeInAndOut: true
                });

                console.log("Displaying: " + latestResult)                

                window.setTimeout(function() {
                    self.setState({ fadeInAndOut: false });
                }, 5000);
            }            
        }, 10000);
    }

    componentWillReceiveProps = (nextProps) => {
        if(this.props.results !== nextProps.results) {
            this.results = this.results.concat(nextProps.results);
        }
    }

    render() {
        return (
            <p className={"LatestResult" + (this.state.fadeInAndOut ? " fadeIn" : "")}>{this.state.latestResult}</p>
		)
	}
}

module.exports = LatestResults;


// WEBPACK FOOTER //
// ./src/components/MDC/LiveGameSummary/LatestResults.js